import React, { useEffect, useRef, useState } from 'react'

import Component7 from '../components/component7'
import styles from './family2.module.css'
import { AnimationOnScroll } from 'react-animation-on-scroll';
import Component8 from '../components/component8';

const Family2 = (props) => {
  const imageRef = useRef(null);
  const [imageWidth, setImageWidth] = useState();

// useEffect(() => {
//   if (imageRef.current) {
//     setImageWidth(imageRef.current.offsetWidth); // Get the image width in pixels
//     console.log('Image Width:', imageRef.current.offsetWidth); // Debug the width
//   }

//   const handleResize = () => {
//     if (imageRef.current) {
//       setImageWidth(imageRef.current.offsetWidth); // Update width on window resize
//       console.log('Updated Image Width:', imageRef.current.offsetWidth); // Debug the updated width
//     }
//   };

//   window.addEventListener('resize', handleResize);
//   return () => window.removeEventListener('resize', handleResize);
// },  []);
useEffect(() => {
  console.log('imageRef.current:', imageRef.current); // Debug the ref
  const updateImageWidth = () => {
    if (imageRef.current) {
      setImageWidth(imageRef.current.offsetWidth); // Get the image width in pixels
      console.log('Image Width:', imageRef.current.offsetWidth); // Debug the width
    }
  };

  updateImageWidth(); // Call it initially to set the width

  window.addEventListener('resize', updateImageWidth); // Update width on resize
  return () => window.removeEventListener('resize', updateImageWidth); // Cleanup
}, []);
  return (
    // <div className={styles['container']}>
    //   <AnimationOnScroll animateIn="animate__zoomIn" delay="300" duration ="2.5">
    //   <Component8 rootClassName="root-class-name"></Component8>
    //   </AnimationOnScroll>
    // </div>
    <div className={styles['container']}>
      <AnimationOnScroll animateIn="animate__zoomIn" delay="300" duration ="2.5">
        <div className={styles['image-wrapper']}>
            <img
            ref={imageRef}
              alt="image"
              src="/playground_assets/family4.png"
              className={styles['image']}
               onLoad={() => {
    if (imageRef.current) {
      setImageWidth(imageRef.current.offsetWidth); // Get the image width after it loads
      console.log('Image Width on Load:', imageRef.current.offsetWidth); // Debug the width
    }
  }}
            />
          </div>
      </AnimationOnScroll>
      <Component8 imageWidth={imageWidth} />
    </div>
  )
}

export default Family2
